import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateModelPricingsMutation, UpdateModelPricingsMutationVariables } from '@/graphql/generated/graphql';
import { UpdateModelPricingsDocument } from '@/graphql/generated/graphql';
export type ModelPricingsUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  Model?: string
  PromptCostPerk?: number
  CompletionCostPerk?: number
}

export type UpdateModelPricingsResponse = {
  data: {
    updateModelPricings: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateModelPricing = () => {
  const mutation = useMutation({
    mutationKey: ['update-model-pricing'],
    mutationFn: (variables: ModelPricingsUpdateInput) => {
      return graphqlClient.request<UpdateModelPricingsMutation>(UpdateModelPricingsDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateModelPricing: mutation.mutate,
    updateModelPricingAsync: mutation.mutateAsync,
  }
}

export const UPDATE_MODEL_PRICING_MUTATION = UpdateModelPricingsDocument;
